<template>
  <section id="how-it-works">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <div class="title">
            <h2>Si funksionon?</h2>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12">
          <div class="how-it-works">
            <img src="/img/pakot.svg">
            <h4>Zgjedh njërën nga pakot</h4>
            <h5>Zgjedh njeren nga pakot tona dhe vazhdo duke plotesuar formen e aplikimit</h5>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12">
          <div class="how-it-works">
            <img src="/img/forma.svg">
            <h4>Plotëso formën</h4>
            <h5>Forma e aplikimit perbehet nga disa hapa, duhet te plotesohen te gjitha te dhenat e kerkuara</h5>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12">
          <div class="how-it-works">
            <img src="/img/pagesa.svg">
            <h4>Proceso pagesën</h4>
            <h5>Pagesa mund te behet ne dy menyra, permes bankes apo me kartele</h5>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12">
          <div class="how-it-works">
            <img src="/img/email.svg">
            <h4>Të dhënat në E-Mail</h4>
            <h5>Pas perfundimit te procedurave te aplikimit, ne e-mail do ju vijn te dhenat per qasje ne platformen tone.</h5>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style src="@/assets/client/css/main.css">
</style>

<script>
export default {
  name: "HowItWorks"
};
</script>
